let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1fbWC")).then(() => parcelRequire('415rW'));